//请自行添加语言资源
const settlementCostIncomeReport = {
  customerOrderNo: '客户订单号',
  orderDate: '订单日期',
  projectCode: '项目代码',
  projectName: '项目',
  costCode: '成本中心代码',
  costName: '成本中心',
  shipperCode: '货主编码',
  shipperName: '货主',
  soOrSto: '客户相关单号',
  checkoutMethod: '结算方式',
  originAddrCode: '发货编码',
  originAddrName: '发货方',
  originAddrProvinceName: '发货省',
  originAddrCityName: '发货市',
  destAddrName: '收货方',
  destAddrCode: '收货编码',
  destAddrProvinceName: '收货省',
  destAddrCityName: '收货市',
  destAddrLocation: '收货地址',
  totalQty: '总数量',
  totalWeight: '总毛重',
  totalVolume: '总体积',
  carrierNo: '承运商代码',
  carrierName: '承运商名称',
  deliverGoodsTime: '发货时间',
  transTypeName: '运输方式',
  dispatchRemark: '发货备注',
  costFreight: '运输费用',
  costDeliveryFee: '提货费',
  costDeliveryCharge: '送货费',
  costPackageFare: '包车费',
  costElseExpense: '其他支出',
  costTotalExpense: '总费用',
  costRemark: '成本异常备注',

  incomeFreight: '运输收入',
  incomeUpstairsFee: '上楼费',
  incomeTerminalCharges: '装卸费',
  incomeValueAddedIncome: '增值收入',
  incomeElseIncome: '其他收入',
  incomeTotalExpense: '总收入',
  incomeRemark: '收入异常备注',
  checkoutStatus: '结算状态',
  gross: '毛利',
  grossRate: '利率',
  settlementClosingFlag: '是否关账',
  closeMonth: '关账月份',
};
export default settlementCostIncomeReport




// WEBPACK FOOTER //
// ./src/page/settlementFee/settlementCostIncomeReport/lang/settlementCostIncomeReport.zh.js